import { useAppDispatch } from "../../../../../redux/hooks";
import { fetchReprintDeliverySheet } from "../../../../../redux/api/expedition.api";
import { DeliverySheetsDataInterface } from "../../../../../redux/interfaces/expedition.interface";

import ActionMenu from "../../../../../components/actionMenu/ActionMenu";

function DeliverySheetActionButtons({
  itemId,
}: {
  itemId: string;
  crudData: DeliverySheetsDataInterface;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();

  const fetchReprintSheetA4 = () => {
    if (itemId) {
      dispatch(
        fetchReprintDeliverySheet({
          idBorderou: itemId,
        }),
      );
    }
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`Borderou ${itemId}`}
      ariaLabel={`Actiuni pentru borderou ${itemId}`}
      items={[
        {
          id: "reprint-sheet",
          label: "Retiparire",
          icon: "PRINT_A4",
          kind: "print",
          tooltip:
            "Genereaza PDF-ul borderoului selectat pentru retiparire.",
          withConfirmationModal: {
            modalTitle: "Retipareste borderou",
            modalSubtitle: "Esti sigur ca vrei sa retiparesti borderoul?",
            modalLeftButtonText: "Anuleaza",
            modalLeftButtonVariant: "outlined",
            modalRightButtonText: "Retipareste",
            modalRightButtonOnClick: fetchReprintSheetA4,
          },
        },
      ]}
    />
  );
}

export default DeliverySheetActionButtons;
